/**
 * Add BASE_URL to the SCE whitelist
 * @param {Object} $sceProvider
 */
export function setSceOptions($sceProvider) {
	'ngInject';
	$sceProvider.enabled(false);
}
